import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OrganizationalGoalList from './OrgRecommendationList';
import OrganizationalGoal from './OrgRecommendationDetails';

function OrganzationalIndex() {
  return (
    <>
      <Routes>
        <Route path="/" element={<OrganizationalGoalList />} />
        <Route path="/details/:id" element={<OrganizationalGoal />} />
        <Route path="/details/create" element={<OrganizationalGoal />} />
      </Routes>
    </>
  );
}

export default OrganzationalIndex;
